import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';

import { redirectToVisitType } from '../../../utils/appointments/redirect-utils';
import Shape from '../../common/Shape';
import AppointmentHeader from '../Components/AppointmentHeader';
import { APPOINTMENT_INSPECTION, PUBLIX_CODE } from '../../../constants';
import { getFullAdress } from '../helpers/getFullLocationAdress';
import { enhance } from './enhance';

import styles from './styles.styl';
import { usePageView } from '../../../hocs/usePageView';
import MetaHelmet from '../../AppHelmet/MetaHelmet';

function AppointmentLocations({
  setLocation,
  locations,
  visitType,
  inspectAll,
  careUser,
  intl: { formatMessage },
}) {
  usePageView('Get Care | Locations');

  const isPublixInfo = visitType.code === PUBLIX_CODE;

  const handleLocationSelect = location => {
    if (!isPublixInfo) {
      setLocation(location);
      inspectAll({
        userId: careUser.id,
        inspectionFor: [APPOINTMENT_INSPECTION.LOCAL_PROFILE],
      });
    }
  };

  const getAddressAndPhone = location => (
    <Fragment>
      {getFullAdress(location)}
      {isPublixInfo && location.phone ? (
        <span>{`, ${location.phone}`}</span>
      ) : (
        ''
      )}
    </Fragment>
  );

  const getWaitTime = location =>
    !!location.approximateWaitTime && (
      <span>
        {formatMessage({ id: 'appointmentForm.appointmentLocations.waitTime' })}
        : &nbsp;
        <strong>
          {location.approximateWaitTime}{' '}
          {formatMessage({
            id: 'appointmentForm.appointmentLocations.minutes',
          })}
        </strong>
      </span>
    );

  return (
    <Fragment>
      <MetaHelmet title="pages.title.getCare.locations" />
      <AppointmentHeader
        type="name"
        title="visitType.locations"
        typeName={visitType.name}
        handleBack={redirectToVisitType}
      />
      <div>
        {locations.map(location => (
          <Shape
            key={location.id}
            className={
              !isPublixInfo
                ? styles.location
                : `${styles.location} ${styles.pointer}`
            }
            onClick={() => handleLocationSelect(location)}
            renderPrimary={() => location.name}
            renderSecondary={() => getAddressAndPhone(location)}
            renderRight={() => getWaitTime(location)}
          />
        ))}
      </div>
    </Fragment>
  );
}

AppointmentLocations.propTypes = {
  setLocation: PropTypes.func,
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      phone: PropTypes.string,
      address: PropTypes.string,
      city: PropTypes.string,
      code: PropTypes.string,
      state: PropTypes.string,
      zip: PropTypes.string,
      approximateWaitTime: PropTypes.number,
    }),
  ),
  visitType: PropTypes.object,
  inspectAll: PropTypes.func,
  careUser: PropTypes.object,
  intl: { formatMessage: PropTypes.func },
};

export default enhance(AppointmentLocations);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentLocations/index.jsx